/*
 * @Date: 2024-05-08 13:54:56
 * @LastEditTime: 2024-05-21 11:20:24
 */
// 深拷贝对象,并能指定删除对象键
export const cloneDeep = (obj, ...agrs) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (Array.isArray(obj)) {
    let copy = [];
    for (let i = 0; i < obj.length; i++) {
      copy.push(cloneDeep(obj[i]));
    }
    return copy;
  }
  let copy = {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && !agrs.includes(key)) {
      copy[key] = cloneDeep(obj[key], agrs);
    }
  }
  return copy;
};
